import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import {
  CheckBox,
  RadioButtonChecked,
  TextFields,
  Numbers,
  Star,
  ToggleOn,
} from '@mui/icons-material';
import { QuestionType, QUESTION_TYPE_CONFIGS } from '../types';

interface QuestionTypeDisplayProps {
  type: QuestionType;
}

export const QuestionTypeDisplay: React.FC<QuestionTypeDisplayProps> = ({ type }) => {
  const typeConfig = QUESTION_TYPE_CONFIGS.find((config) => config.type === type);

  const getIcon = (iconName: string) => {
    const iconProps = {
      fontSize: 'large' as const,
      color: 'primary' as const,
    };

    switch (iconName) {
      case 'CheckBox':
        return <CheckBox {...iconProps} />;
      case 'RadioButtonChecked':
        return <RadioButtonChecked {...iconProps} />;
      case 'TextFields':
        return <TextFields {...iconProps} />;
      case 'Numbers':
        return <Numbers {...iconProps} />;
      case 'Star':
        return <Star {...iconProps} />;
      default:
        return <ToggleOn {...iconProps} />;
    }
  };

  if (!typeConfig) {
    return null;
  }

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      {/* Icon Circle */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 56,
          height: 56,
          borderRadius: '50%',
          backgroundColor: 'action.selected',
          flexShrink: 0,
        }}
      >
        {getIcon(typeConfig.icon)}
      </Box>

      {/* Title and Description */}
      <Box>
        <Typography variant="subtitle1" fontWeight={600} color="text.primary">
          {typeConfig.label}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {typeConfig.description}
        </Typography>
      </Box>
    </Stack>
  );
};
